import React from 'react';
import {i18n} from "../utils";

i18n.initialize();

const Error = (props) => {
    const { generic, message } = props;

    return (
        <div className="full-message result-message product-expired">

            <div className="image-error-container">
                <img className="img-error" src={require('../assets/error.png')} alt="Icono producto expirado"/>
            </div>

            <h2>
                { message ? message : i18n.t(generic) }
            </h2>

        </div>
    );
}
export default Error



// WEBPACK FOOTER //
// ./client/components/Error.js